import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PortalService } from 'app/core/portal/portal.service';

// Routes that portal (email link / external) users are permitted to access
const PORTAL_ALLOWED_ROUTES = ['submissions', 'jobs', 'profile'];

@Injectable({
    providedIn: 'root'
})
export class PortalGuard
{
    constructor(
        private _portalService: PortalService,
        private _router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean
    {
        return this._check(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean
    {
        return this._check(state.url);
    }

    private _check(url: string): Observable<boolean>
    {
        // Non-portal users: always allow through
        if (!this._portalService.isPortal()) {
            return of(true);
        }

        // Portal users: only allow access to permitted routes
        const isAllowed = PORTAL_ALLOWED_ROUTES.some(route => url.startsWith('/' + route));
        if (!isAllowed) {
            this._router.navigate(['submissions']);
            return of(false);
        }

        return of(true);
    }
}
